import {SkeletonBlock} from '@aboutyou/ui-components';
import React, {Fragment} from 'react';
import styled from 'styled-components';

export const LoadingPlaceholder = () => {
  return (
    <Fragment>
      <SkeletonBlock style={{marginTop: 40}} $width="50%" $height="40px" />
      <Wrapper>
        <SkeletonBlock $width="350px" $height="20px" />
        <SkeletonBlock $width="450px" $height="40px" />
        <SkeletonBlock $width="250px" $height="20px" />
        <SkeletonBlock $width="300px" $height="40px" />
      </Wrapper>
    </Fragment>
  );
};

const Wrapper = styled.div`
  margin: 20px 0;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  max-width: 100%;
`;
